import { SVGProps } from "react";

export default function NextArrowIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 14, width = 14, stroke = "#F6F3EF", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8.41406 3.45898L11.9549 6.99982L8.41406 10.5407"
        stroke={stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.03906 7H11.8566"
        stroke={stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
